<template>
  <div class="flow-bd">
    <div class="ub">
      <div v-for="(item, index) in flowList" :class="[{'ub-f1': !item},{'flow-item': item}, {'cur': index=== currentIndex}, {'pass': index < currentIndex}]">
        <div v-if="item" class="dit"><small></small></div>
        <div v-if="item" class="txt centerX">{{item}}</div>
      </div>
    </div>
  </div>
</template>
<script>
/**
   * @param list [Array] 流程文字字符串数组
   * @param value [String] 当前流程位置
   * @describe
   *
   * @example
   *
    <t-flow :list="['申请注册', '等待客服联系', '注册成功']" v-model=''></t-flow>
   */

export default {
  name: 'tFlow',
  props: {
    list: {
      type: Array,
      default: [],
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {};
  },
  computed: {
    flowList: function () {
      const arrayList = new Array(this.list.length * 2 - 1);
      this.list.forEach((item, index) => {
        arrayList[index * 2] = item;
      });
      return arrayList;
    },
    currentIndex: function () {
      return this.flowList.findIndex(t => t === this.value);
    },
  },
  methods: {

  },
};

</script>
<style lang="scss">
.flow-bd {
  padding-top: 0.25rem;
  .ub{
    align-items: center;
  }
  .flow-item {
    position: relative;
    .dit {
      height: 0.1rem;
      width: 0.1rem;
      border-radius: 50%;
      background-color: #ffffff;
      small {
        float: left;
        margin-top: 0.03rem;
        margin-left: 0.03rem;
        width: 0.04rem;
        height: 0.04rem;
        border-radius: 50%;
        background-color: #d8d8d8;
      }
    }
    &.pass .dit {
      small {
        background-color: #FFDE02;
      }
    }
    &.cur .dit {
      height: 0.11rem;
      width: 0.11rem;
      background-color: #333;
      small {
        margin-top: 0.03rem;
        margin-left: 0.03rem;
        width: 0.05rem;
        height: 0.05rem;
        background-color: #FFDE02;
      }
    }
    .txt {
      color: #2D2D2D;
      font-size: 0.12rem;
      white-space: nowrap;
      bottom: 0.2rem;
      line-height: 0.16rem;
    }
  }
  .ub-f1 {
    background-color: #E2E2E2;
    height: 1px;
    &.pass {
      background-color: #FFDE02;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/flow.vue